{
  "advisor.confirmation": "Revisorstadfesting",
  "advisor.confirmation.none.uploaded": "Inga revisorstadfesting er lasta opp",
  "back.to.reports": "Tilbake til rapportering",
  "budget": "Budsjett",
  "budget.none.uploaded": "Inga budsjetter er lasta opp",
  "budget.upload.confirmation.text": "I budsjetåret {{ year }} er denne fila lasta opp",
  "budget.upload.confirmation.text.fileName.changes": "Vi har endra filnamnet til",
  "budget.upload.error.description": "Noko gjekk gale under opplastinga av fila, ver venleg og prøv igjen.",
  "budget.upload.error.title": "Noko gjekk gale!",
  "budget.year": "Budsjettår",
  "company.details.contract.overview.selfDeclaration": "Eigenerklæring",
  "company.details.contract.overview.selfDeclarationValidTo": "Gyldig til: {{date}}",
  "company.details.contract.overview.id": "ID",
  "company.details.esa.total": "Totalt",
  "download.file.error": "Kunne ikkje lasta ned fil. Ver vennleg og prøv igjen.",
  "error.acceptedDateAfterRegisteredDate": "Opptaksdato må være etter registreringsdato {{readableRegistrationDate}}",
  "export.goalAccomplishment.header": "Eksporter måloppnåelse",
  "export.goalAccomplishment.exportButton": "Eksporter måloppnåelse for",
  "export.ideasAndCompanies.header": "Eksporter idéar og bedrifter",
  "export.ideasAndCompanies.exportButton": "Last ned totalrapport",
  "export.ideasAndCompanies.yearLabel": "Totalrapport for",
  "export.ktu.exportButton": "Last ned KTU-rapport",
  "export.ktu.header": "Kundetilfredsheitsundersøkinga (KTU)",
  "export.reportingYear": "Rapportår",
  "reporting.status.closeYear": "Lukk rapportår",
  "reporting.status.openYear": "Opne rapportår",
  "reporting.status.closedToast": "Lukka {{year}} for {{actorCount}} aktørar.",
  "reporting.status.openedToast": "Opna {{year}} for {{actorCount}} aktørar.",
  "reporting.status.error": "Noko gjekk gale. Oppdater sida for å sjå status.",
  "file.none.choosen": "Ingen filtype er valde",
  "file.type": "Filtype",
  "file.type.plural": "Filtyper",
  "files": "Filer",
  "hide.previous.files": "Gøym tidlegare filer",
  "idea.mainContact": "Hovudkontakt",
  "idea.name": "Idénamn*",
  "idea.edit": "Rediger idé",
  "networkLogo": "Nettverkslogo",
  "notification.siva.summary.report": "Siva har gitt dykk tilbakemeldinger på måltall {{ year }}",
  "notification.siva.summary.report.url": "Sjå kommentarar",
  "show.previous.files": "Vis tidlegare filer",
  "type.choose": "Vel type",
  "upload.files": "Last opp filer",
  "upload.file": "Last opp fil",
  "upload.file.drag": "eller dra den hit",
  "notification.siva.summary.approved": "Siva har godkjent måltala dykkar for {{ year }}",
  "notification.siva.summary.approved.url": "Sjå måltal {{ year }}",
  "phase.OtherPhases": "Andre fasar",
  "phase.select": "Velg fase",
  "contract.edit.connectCompany": "Knytt til bedrift",
  "contract.edit.noCompany.text": "Har ikkje org. nummer enno, vil legge til bedrift med org. nummer seinare.",
  "contract.edit.noCompany.ariaLabel": "Inga bedrift med org. nummer, skal legge til seinare.",
  "reporting.selfdeclaration.classification": "Sjølvklassifisering",
  "reporting.selfdeclaration.dialog.title": "Registrer oppdatert eigenerklæring",
  "reporting.selfdeclaration.deliveredDate": "Innsendingsdato",
  "reporting.selfdeclaration.registerUpdatedQuestion": "Det finst allereie ei eigenerklæring for denne avtalen. Vil du registrere ei oppdatert ei?",
  "reporting.selfdeclaration.registerUpdatedConfirm": "Registrer oppdatert",
  "company.details.contract.overview.exitDate.required": "Vel ein utgangsdato for denne bedrifta",
  "goalAccomplishment.Total.YearError": "Kan ikkje oppdatere måloppnå",
  "changePhase.error.title": "Beklagar, vi kunne ikkje endre fase",
  "changePhase.error.text": "Prøv gjerne på nytt eller kontakt oss om feilen vedvarar",
  "changePhase.selfDeclaration.error.title": "Beklagar, vi kunne ikkje lagre eigenerklæringa",
  "changePhase.selfDeclaration.error.text": "Faseendringa vart lagra, men lagring av eigenerklæringa feila. Prøv igjen eller kontakt oss om feilen vedvarar",
  "ideasAndCompanies.terminateChosenIdeas": "Avslutt valde idéar",
  "ideasAndCompanies.wantToTerminate": "Vil du avslutte",
  "ideasAndCompanies.chosenIdeasSingular": "valt idé? Denne vil bli avslutta med direkte verknad.",
  "ideasAndCompanies.chosenIdeasPlural": "valde idéar? Disse vil bli avslutta med direkte verknad.",
  "ideasAndCompanies.terminate": "Avslutt idéar",
  "ideasAndCompanies.reopenChosenIdeasCompanies": "Gjenopne valde idéar/bedrifter",
  "ideasAndCompanies.wantToReopen": "Vil du gjenopne",
  "ideasAndCompanies.chosenIdeasCompaniesSingular": "valt idé/bedrift?",
  "ideasAndCompanies.chosenIdeasCompaniesPlural": "valde idéar/bedrifter?",
  "ideasAndCompanies.reopenChosen": "Gjenopne valte",
  "ideasAndCompanies.reopenIdeasCompanies": "Gjenopne idéar/bedrifter",
  "ideasAndCompanies.generalErrorMessage": "Det har oppstått en feil. Prøv på nytt seinare. Dersom feilen halde fram, kontakt oss.",
  "ideasAndCompanies.generalErrorHeader": "Feilmelding",
  "ideasAndCompanies.ideasTerminatedPlural.header": "{{ count }} idéar er avslutta",
  "ideasAndCompanies.ideasTerminatedPlural.text": "Idéane er flytta til fana Alle alumni og kan gjenopnes derfrå.",
  "ideasAndCompanies.ideasTerminatedSingular.header": "{{ count }} idé er avslutta",
  "ideasAndCompanies.ideasTerminatedSingular.text": "Idéen er flytta til fana Alle alumni og kan gjenopnes derfrå.",
  "ideasAndCompanies.ideasCompaniesReopenedPlural": "{{ count }} inaktive idéar/bedrifter er gjenopna",
  "ideasAndCompanies.ideasCompaniesReopenedSingular": "{{ count }} inaktiv idé/bedrift er gjenopna",
  "ideasAndCompanies.delete.confirm": "Er du sikker på at du vil slette {{ contract }}?",
  "ideasAndCompanies.resultsMetrics.header": "Resultat måltal",
  "ideasAndCompanies.changesAreAutomatic.text": "Endringane er automatisk lagra kl.",
  "ideasAndCompanies.reportingYearIsClosed.text": "Dette rapporteringsåret er lukka, og kan ikkje redigerast. Kontakt Siva om du treng å korrigera måloppnåing.",
  "ideasAndCompanies.editResults.buttonText": "Rediger resultat",
  "ideasAndCompanies.exitEditing.buttonText": "Avslutt redigering",
  "ideasAndCompanies.internationalMarketOptionPositive.text": "Ja",
  "ideasAndCompanies.internationalMarketOptionNegative.text": "Nei",
  "ideasAndCompanies.internationalMarketOptionPotential.text": "Nei, men har internasjonalt marknadspotensiale",
  "newCompany.dialog.text.created": "Avtale opprettet",
  "newCompany.buttons.complete": "Fullfør og legg til bedrift",
  "admittedToProgram": "Tatt opp i program",
  "ideaConsidered": "Idé vurdert",
  "companyTabs.tabs.about": "Om bedrifta",
  "companyTabs.tabs.register": "Register",
  "companyTabs.tabs.economy": "Regnskap",
  "companyTabs.tabs.applications": "Tidligere søknadar",
  "companyTabs.error.loadingFailed": "Kunne ikkje laste bedriftsinfo. Kontakt support om feilen held fram.",
  "companyTabs.about.registeredDate": "Registreringsdato",
  "companyTabs.applications.table.title": "Tidligere bevillingar og søknadar",
  "report.goals": "Måltal",
  "report.goals.difference.higher": "Ny verdi er høgare med +{{difference}}",
  "report.goals.difference.higherPercentage": "Ny verdi er høgare med +{{difference}} prosentpoeng",
  "report.goals.difference.lower": "Ny verdi er lågare med {{difference}}",
  "report.goals.difference.lowerPercentage": "Ny verdi er lågare med {{difference}} prosentpoeng",
  "report.goals.difference.unchanged": "Ny verdi er lik den førre",
  "report.goals.eu.negative": "Vesentleg negativ",
  "report.goals.eu.positive": "Vesentleg positiv",
  "report.goals.export.potensiale": "Nei, men har eksportpotensiale",
  "report.goals.export.underleverandor": "Nei, men er underleverandør til eksportbedrift",
  "report.goals.eu.none": "Ingen",
  "idea.description": "Idéskildring",
  "newIdeaForm.section.subTitle.contact": "Kontaktinformasjonen til idéhavar",
  "newCompany.contract.section.info.title": "Avtaleinformasjon",
  "newCompany.contract.form.fromDate.label": "Opptaksdato",
  "newCompany.contract.form.ideaSource.placeholder": "Vel idékjelde...",
  "newCompany.contract.form.externalIndustry.placeholder": "Vel bransje...",
  "newCompany.contract.form.registrationDate.label": "Registreringsdato",
  "programAdmission.title": "Opptak til program",
  "programAdmission.cannotAdmit.title": "Kan ikkje ta opp henvendelse",
  "programAdmission.cannotAdmit.text": "For å ta opp til eit program må du først tilknytte ei bedrift.",
  "programAdmission.connectCompany": "Tilknytt bedrift",
  "programAdmission.addedToast": "{{name}} med fase {{phase}} vart lagt til.",
  "programAdmission.noAvailablePhases.businessGarden": "{{name}} har allereie ein avtale. Berre éin avtale kan registrerast per bedrift.",
  "programAdmission.noAvailablePhases.incubator": "{{name}} har allereie ein avtale i ein annan fase enn {{phase}}. Berre éin fase kan registrerast per bedrift unntatt {{phase}}.",
  "error.support.message": "Prøv gjerne på nytt eller kontakt oss på",
  "newCompany.contract.form.name.label": "Idénamn",
  "newCompany.contract.form.name.description": "Ei kort skildring av forretningsidéen. Dette vil bli vist i bedriftsoversikta",
  "newCompany.contract.form.name.required": "Namn er påkravd så framt inga bedrift er lagt til",
  "newCompany.contract.form.ideaSource.label": "Idékjelde",
  "newCompany.contract.form.ideaSource.required": "Idékjelde er påkravd for idéar",
  "newCompany.contract.form.externalIndustry.label": "Bransje",
  "newCompany.contract.form.externalIndustry.required": "Ver venleg og angi kva bransje bedrifta høyrer inn under.",
  "newCompany.contract.form.fromDate.required": "Vel ein dato for opptak av denne bedrifta",
  "newCompany.contract.form.fromDate.sameYear": "Kan berre velje ein dato i inneverande år.",
  "newCompany.contract.form.formStartupDate.label": "Utsending av oppstartsskjema",
  "newCompany.contract.form.formMidDate.label": "Utsending av undervegsskjema",
  "newCompany.contract.form.ideaName.maxLength": "Idénamn kan maksimalt vere {{value}} teikn. Bruk notatfeltet dersom du har behov for notat.",
  "newCompany.contract.form.municipality.label": "Kommune",
  "newCompany.contract.section.contact.title": "Kontakt",
  "newCompany.contract.form.contactFirstName.label": "Fornamn",
  "newCompany.contract.form.contactFirstName.required": "Skriv fornamnet til kontaktpersonen",
  "newCompany.contract.form.contactLastName.label": "Etternamn",
  "newCompany.contract.form.contactLastName.required": "Skriv etternamnet til kontaktpersonen",
  "newCompany.contract.form.contactEmail.label": "E-post",
  "newCompany.contract.form.contactEmail.required": "Skriv e-postadressa til kontaktpersonen",
  "newCompany.contract.form.contactEmail.validateEmail": "Skriv inn ei gyldig e-postadresse til kontaktpersonen",
  "newCompany.contract.section.followUp.title": "Oppfølging",
  "newCompany.contract.form.advisorId.required": "Vel ein rådgivar som skal følgje opp bedrifta (denne avtalen eller dette prosjektet)",
  "newCompany.contract.form.advisorId.link.text": "Finn ikkje rådgivar? Du kan leggje til tilsette i",
  "newCompany.contract.form.notes.label": "Notat",
  "newCompany.contract.form.notes.label.description": "Notatet vil bli synleg i aktivitetsloggen",
  "newCompany.contract.form.notes.maxLength": "Notat kan maksimalt vere 1000 teikn",
  "newCompany.contract.form.errors": "Det er éin eller fleire feil i skjemaet. Sjekk at du har skrive inn alle felt korrekt og prøv igjen."
}
